const NAME = "BENEFITS_CENTER";

export default NAME;
